import styled from 'styled-components';
import { Paper } from '@material-ui/core';

export const UIPaperFullWidth = styled(Paper)`
  width: 100% !important;
`;

export default UIPaperFullWidth;
